import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zerofill'
})
export class ZerofillPipe implements PipeTransform {

  transform(value: any, width:number=1): string {
    const numberOutput = Math.abs(value); /* Valor absoluto del número */
    const length = value.toString().length; /* Largo del número */ 
    const zero = "0"; /* String de cero */  
    
    if (width <= length) {
        if (value < 0) {
             return ("-" + numberOutput.toString()); 
        } else {
             return numberOutput.toString(); 
        }
    } else {
        if (value < 0) {
            return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
        } else {
            return ((zero.repeat(width - length)) + numberOutput.toString()); 
        }
    }
}

}
